const config = require("../config")

module.exports = {
    // 获取初始互动接口
    getInitialInteraction: {
        url: config.base_new_url + "pheno/initial_interact_options",
        type: "get",
    },
    // 无分区时获取初始互动选项（录入品种页）
    getInitialInteractionWithoutZone: {
        url: config.base_new_url + "pheno/initial_interact_options_without_zone",
        type: "get",
    },
    // 保存感知结果接口
    saveInteractResult: {
        url: config.base_new_url + "pheno/interact_record",
        type: "post",
    },
    // 查看报告是否生成
    checkReportGenerated: {
        url: config.base_new_url + "report/check",
        type: "get",
    },
    // 获取外部感知任务接口
    getExternalInteractTasks: {
        url: config.base_new_url + "pheno/outer_interact_tasks",
        type: "get",
    },
    // 获取内部感知任务接口
    getInternalInteractTasks: {
        url: config.base_new_url + "pheno/inner_interact_tasks",
        type: "get",
    },
    // 分区农事任务列表：GET /api/questionnaire/zone_fw_task_list
    // 参数 zone_id + farm_id + trigger_date + crop_type
    // 返回 fw_tasks（标准）/ weather_work（气象）/ abnormal_fw_tasks（异常）
    getZoneFwTaskList: {
        url: config.base_new_url + "questionnaire/zone_fw_task_list",
        type: "get",
    },
    // 获取农事详细内容（人工 / 机械方案）
    getFwTaskDetails: {
        url: config.base_new_url + "pheno/fw_task_details",
        type: "get",
    },
    // 查询当前农户/农资下的果园信息
    getFarms: {
        url: config.base_new_url + "questionnaire/find_farm_information",
        type: "get",
    },
    // 查询是否填写农场信息
    checkFarmInit: {
        url: config.base_new_url + "questionnaire/farm_init/get",
        type: "get",
    },
    // 填写农场信息弹窗更新状态
    updateFarmInitStatus: {
        url: config.base_new_url + "questionnaire/farm_init/set",
        type: "post",
    },
    // 查询分区照片数量
    getZones: {
        url: config.base_new_url + "questionnaire/zone_images",
        type: "get",
    },
    // 查询是否填写农事弹窗
    checkFwInit: {
        url: config.base_new_url + "questionnaire/work_init/get",
        type: "get",
    },
    // 填写农场农事弹窗更新状态
    updateFwInitStatus: {
        url: config.base_new_url + "questionnaire/work_init/set",
        type: "post",
    },
    // 查询首页气象胁迫信息
    getWeatherReport: {
        url: config.base_new_url + "questionnaire/risk_report_info",
        type: "get",
    },
    // 查询气象预警报告
    getWeatherRisk: {
        url: config.base_new_url + "questionnaire/weather_risk_report",
        type: "get",
    },
    // 查询气象胁迫报告
    getWeatherStress: {
        url: config.base_new_url + "questionnaire/weather_stress_report",
        type: "get",
    },
    // 上传图片
    uploadImages: {
        url: config.base_new_url + "questionnaire/upload_image",
        type: "post",
    },
    // 查询分区照片列表
    getZoneImages: {
        url: config.base_new_url + "questionnaire/zone_image_list",
        type: "get",
    },
    // 诊断报告列表
    getReportList: {
        url: config.base_new_url + "questionnaire/weather_report_list",
        type: "get",
    },
    // 新建分区
    createZone: {
        url: config.base_new_url + "questionnaire/add_zone_info",
        type: "post",
    },
    // 查询分区是否有范围
    checkZoneRange: {
        url: config.base_new_url + "questionnaire/check_zone_polygon",
        type: "get",
    },
    // 分区画范围
    drawZoneRange: {
        url: config.base_new_url + "questionnaire/update_zone_polygon",
        type: "post",
    },
    // 首页气象底图
    getHomeMapCalc: {
        url: config.base_new_url + "questionnaire/get_map_calc",
        type: "get",
    },
    // 异常互动查询
    getAbnormalInteract: {
        url: config.base_new_url + "questionnaire/abnormal_interact_info",
        type: "get",
    },
    // 异常问题确认
    confirmAbnormalInteract: {
        url: config.base_new_url + "questionnaire/abnormal_fw_answer",
        type: "post",
    },
    // 首页生成气象地图
    getHomeMapCalcByCounty: {
        url: config.base_new_url + "questionnaire/get_map_calc_by_county",
        type: "get",
    },
    // 区县查询胁迫报告（无农场，参数 county_code）
    getPointStressReport: {
        url: config.base_new_url + "report/weather_stress_report_latlon",
        type: "get",
    },
    // 区县查询风险报告（无农场，参数 county_code）
    getPointRiskReport: {
        url: config.base_new_url + "report/weather_risk_report_latlon",
        type: "get",
    },
    // 查询地区和品类
    getAreaAndCropType: {
        url: config.base_new_url + "questionnaire/find_farm_information_options",
        type: "get",
    },
    // 外层长势问题互动接口
    getOuterRecords: {
        url: config.base_new_url + "pheno/pheno_template_records",
        type: "get",
    },
}
